<tax-page-header titleText="documents.title"></tax-page-header>

<tax-input
  data-qa-input="search"
  placeholder="documents.search.placeholder"
  taxNumbersOnly
  [tabindex]="0"
  [formControl]="kkmId"
  [autofocus]="true"
  [clearable]="true"
  (cleanEvent)="setDocumentsFilter({ kkmId: null })"
  (keydown.enter)="setDocumentsFilter({ kkmId: kkmId.value })"
></tax-input>

<tax-document-types
  *ngIf="documentTypes$ | async as documentTypes"
  [documentTypes]="documentTypes"
  (selectDocumentType)="setDocumentsFilter($event)"
></tax-document-types>

<tax-document-list
  *ngIf="documents$ | async as documents"
  [documents]="documents"
  [countDisplayedDocuments]="countDisplayedDocuments"
  (changePageSize)="changePageSize()"
></tax-document-list>
